import { toast } from '@oy/uidesktop';
import useTranslate from './useTranslate';

/**
 * A hook that provides a function to copy a text to the clipboard and display toast messages.
 *
 * @returns A function to handle copying text to the clipboard and display toast messages.
 */
export const useCopy = () => {
  const { getTranslation } = useTranslate();

  /**
   * Function to handle copying text to the clipboard and display toast messages.
   *
   * @param txId - The text to be copied to the clipboard.
   * @param successStringKey - The translation key for the success toast message.
   *                           Defaults to 'common_copyToClipboard'.
   * @param errorStringKey - The translation key for the error toast message.
   *                         Defaults to 'multiAccount_failedCopyTxId'.
   */
  const onClickCopyButton = (
    txId: string,
    successStringKey = 'common_copyToClipboard',
    errorStringKey = 'multiAccount_failedCopyTxId',
  ) => {
    navigator.clipboard.writeText(txId).then(
      () => {
        // Display success toast message.
        toast.success(getTranslation(successStringKey));
      },
      () => {
        // Display error toast message.
        toast.error(getTranslation(errorStringKey));
      },
    );
  };

  return onClickCopyButton;
};
